import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

export function CAPA({ parameters, onChange }) {
  return (<div></div>);
}